import { Component, OnInit } from '@angular/core';
import { AvanoButtonBarButtonDetails } from '../avano-button-bar.common';

// TODO: This component will be extended to handle all the logic for collapse/expand all panels on a page
// TODO: Create a service, inject it, handle disable/enable of the buttons, call methods from service

@Component({
  selector: 'avano-button-bar-collapse-expand-all',
  templateUrl: './avano-button-bar-collapse-expand-all.component.html',
  styleUrls: ['./avano-button-bar-collapse-expand-all.component.scss']
})
export class AvanoButtonBarCollapseExpandAllComponent implements OnInit {
  expandCollapseButtons: AvanoButtonBarButtonDetails[];

  constructor() {}

  ngOnInit(): void {
    const expandAllBtn: AvanoButtonBarButtonDetails = {
      icon: 'icon-content-expand-all',
      label: 'Expand All' // TODO: Think about i18n :(
    };
    const collapseAllBtn: AvanoButtonBarButtonDetails = {
      icon: 'icon-content-collapse-all',
      label: 'Collapse All' // TODO: Think about i18n :(
    };

    this.expandCollapseButtons = [expandAllBtn, collapseAllBtn];
  }
}
